<div *ngIf="isVisible$ | async">
  Sorry Looks like something went wrong. We are on the job of fixing it. Thanks for your patience. <i class="glyphicon glyphicon-remove pull-right close-button" (click)="close($event)"></i>
</div>
